import { Check } from "lucide-react";
import { twMerge } from "tailwind-merge";

export function SelectionCheck({
  className,
  isSelected,
}: {
  className?: string;
  isSelected: boolean;
}) {
  return (
    <span
      className={twMerge(
        "flex size-5 shrink-0 items-center justify-center rounded-full border border-border-primary bg-bg-primary transition",
        isSelected && "border-bg-brand-solid bg-bg-brand-solid text-white",
        className,
      )}
    >
      {isSelected && <Check className="size-3" strokeWidth={3} />}
    </span>
  );
}
